import { DateTime } from 'luxon';

export function daysSinceDate(now: DateTime, isoDate_utc: string) {
  const today = now.startOf('day');
  const then = DateTime.fromISO(isoDate_utc).toLocal().startOf('day');
  const daysSince = today.diff(then, 'days').as('days');
  return daysSince;
}
